import React from "react";

// PDF-only note+image pairs attached to a quotation export. Not persisted
// to the backend as structured data — see buildBackendNotes() in the
// parent, which folds each pair's note text into the main notes field.
const NoteImagePairsEditor = ({
  noteImagePairs,
  addNoteImagePair,
  updatePairNote,
  updatePairImage,
  removePairImage,
  removeNoteImagePair,
}) => {
  return (
              <div className="note-image-pairs-section">
                <div className="nip-section-header">
                  <div className="nip-section-title">
                    <h4>Additional Notes &amp; Images</h4>
                    <span className="nip-hint">
                      📄 PDF only — images are not saved to the server. Notes
                      from these pairs are included in the enquiry as bullet
                      points.
                    </span>
                  </div>
                </div>

                {noteImagePairs.length === 0 && (
                  <p className="nip-empty-hint">
                    No pairs added yet. Click &ldquo;Add Note &amp; Image&rdquo;
                    to attach notes with optional reference images to the PDF
                    quotation.
                  </p>
                )}

                {noteImagePairs.map((pair, idx) => (
                  <div key={pair.id} className="nip-pair-card">
                    <div className="nip-pair-header">
                      <span className="nip-pair-label">No {idx + 1}</span>
                      <button
                        type="button"
                        className="nip-remove-btn"
                        onClick={() => removeNoteImagePair(pair.id)}
                        title="Remove this pair"
                      >
                        ✕
                      </button>
                    </div>

                    {/* Note textarea */}
                    <div className="nip-note-row">
                      <label>Note</label>
                      <textarea
                        rows={3}
                        className="nip-note-textarea"
                        placeholder="Enter a note for this section…"
                        value={pair.note}
                        onChange={(e) =>
                          updatePairNote(pair.id, e.target.value)
                        }
                      />
                    </div>

                    {/* Image upload */}
                    <div className="nip-image-row">
                      <label>
                        Image{" "}
                        <span className="nip-optional">
                          (optional — PDF only)
                        </span>
                      </label>

                      {pair.imageDataUrl ? (
                        <div className="nip-image-preview">
                          <img
                            src={pair.imageDataUrl}
                            alt={`Pair ${idx + 1} preview`}
                            className="nip-preview-img"
                          />
                          <button
                            type="button"
                            className="nip-remove-image-btn"
                            onClick={() => removePairImage(pair.id)}
                            title="Remove image"
                          >
                            Remove image
                          </button>
                        </div>
                      ) : (
                        <label
                          className="nip-upload-label"
                          htmlFor={`nip-img-${pair.id}`}
                        >
                          <span className="nip-upload-icon">🖼</span>
                          <span>Click to upload image</span>
                          <input
                            id={`nip-img-${pair.id}`}
                            type="file"
                            accept="image/*"
                            style={{ display: "none" }}
                            onChange={(e) =>
                              updatePairImage(pair.id, e.target.files?.[0])
                            }
                          />
                        </label>
                      )}
                    </div>
                  </div>
                ))}

                <button
                  type="button"
                  className="nip-add-btn"
                  onClick={addNoteImagePair}
                  style={{
                    marginTop: noteImagePairs.length > 0 ? "0.75rem" : "0",
                  }}
                >
                  + Add Note &amp; Image
                </button>
              </div>
  );
};

export default NoteImagePairsEditor;
